import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import ValidationError from "../Shared/ValidationError";
import BaseModal from "./BaseModal";
import { validate } from "../../utils/ValidationHelpers";
import UnitsSchema from "../../schemas/units.schema";
import { t } from "i18next";
import { isEmpty } from "lodash";

const BaseUnitModal = ({
    isVisible,
    setIsVisible,
    unit,
    setUnit,
    editAction,
    addAction,
}) => {
    const [error, setError] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);

    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        validate(unit, UnitsSchema.BaseUnit, setIsFormValid, setError);
    }, [unit]);

    useEffect(() => {
        if (!isVisible) resetForm();
        if (isVisible && !isEmpty(unit)) setIsEdit(true);
    }, [isVisible]);

    const resetForm = () => {
        setUnit({});
        setError({});
        setIsFormValid(false);
        setIsFormSubmitted(false);
        setIsFormSubmitting(false);
        setIsEdit(false);
    };

    const returnErrorMessages = (propName) => {
        return isFormSubmitted && error[propName];
    };

    const handleInputChange = (e) => {
        setUnit((prevParams) => {
            return {
                ...prevParams,
                [e.target.name]: e.target.value?.trim(),
            };
        });
    };

    const submitAction = () => {
        setIsFormSubmitting(true);
        setIsFormSubmitted(true);
        if (isFormValid) {
            isEdit ? editAction() : addAction();
        }
        setIsFormSubmitting(false);
        return;
    };

    const renderChildren = () => (
        <>
            <div
                className={`input-group ${
                    returnErrorMessages("unit") ? "invalid-warning-input" : ""
                }`}
            >
                <label className="uppercase required">
                    <Trans i18nKey="unit">Unit</Trans>
                </label>
                <input
                    className="input-element"
                    name="unit"
                    type="text"
                    onChange={handleInputChange}
                    value={unit?.unit || ""}
                    placeholder={t("unitPlaceholder")}
                />
                <ValidationError errorMessage={returnErrorMessages("unit")} />
            </div>
        </>
    );

    return (
        <>
            <BaseModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                isSubmitting={isFormSubmitting}
                title={t(isEdit ? "editTitle" : "addTitle", {
                    entity: t("unit"),
                })}
                action={{
                    submitAction: submitAction,
                }}
                isMedium={true}
            >
                {renderChildren()}
            </BaseModal>
        </>
    );
};

export default BaseUnitModal;
